/**
 * 过滤器注释
 * @export
 * @param fifterrequirex //工作方案计划重要程度过滤器
 * @param fifterxztype  //工作方案计划性质分类过滤器
 * @param fifternrtype  //工作方案计划内容培训过滤器
 * @param fifteHECK_STATUS // 隐患排查 排查结果过滤器
 * @param fifteOIFRISK // 隐患排查 是否是重大危险源过滤器
 * @param fifteDANGER_LEVEL // 隐患排查 隐患等级源过滤器
 * @param fifteDANGER_SRC //隐患排查 隐患来源
 * @param fifteIF_TRUE //隐患排查 是否合格
 * @param fifteDELETED //隐患排查 审核状态
 */

const vFilter = {
  fifterrequirex: function(text) {
    switch (text) {
      case 0:
        return '一般'
      case 1:
        return '紧急'
      default:
        return text
    }
  },
  fifterxztype: function(text) {
    switch (text) {
      case 0:
        return '政府计划'
      case 1:
        return '单位计划'
      case 2:
        return '企业计划'
      case 3:
        return '部门计划'
      case 4:
        return '单位计划'
      case 5:
        return '岗位计划'
      case 6:
        return '个人计划'
      default:
        return text
    }
  },
  fifternrtype: function(text) {
    switch (text) {
      case 0:
        return '培训教育'
      case 1:
        return '管理制度'
      case 2:
        return '其他'
      default:
        return text
    }
  },
  fifteHECK_STATUS(text) {
    switch (text) {
      case 0:
        return '正常'
      case 1:
        return '存在隐患'
      case 2:
        return '未排查'
      case 3:
        return '其他'
      default:
        return text
    }
  },
  fifteOIFRISK(text) {
    switch (text) {
      case 0:
        return '是'
      case 1:
        return '否'
      default:
        return text
    }
  },
  fifteDANGER_LEVEL(text) {
    switch (text) {
      case 0:
        return '一般隐患'
      case 1:
        return '重大隐患'
      default:
        return text
    }
  },
  fifteDANGER_SRC(text) {
    switch (text) {
      case 1:
        return '日常排查'
      case 2:
        return '综合性排查'
      case 3:
        return '专业性排查'
      case 4:
        return '季节性排查'
      case 5:
        return '重点时段及节假日前排查'
      case 6:
        return '事故类比排查'
      case 7:
        return '复产复工前排查'
      case 8:
        return '外聘专家诊断式排查'
      case 9:
        return '管控措施失效'
      case 10:
        return '其他'
      default:
        return text
    }
  },
  fifteIF_TRUE(text) {
    switch (text) {
      case 0:
        return '是'
      case 1:
        return '否'
      default:
        return text
    }
  },
  fifteDELETED(text) {
    switch (text) {
      case 0:
        return '审核中'
      case 1:
        return '审核未通过'
      case 2:
        return '审核通过'
      default:
        return text
    }
  },

  fiftestatusx(text) {
    switch (text) {
      case 0:
        return '启用'
      case 1:
        return '禁用'
      default:
        return text
    }
  },
  fifterEXECUTION_STATUS(text) {
    switch (text) {
      case 3:
        return '待治理'
      case 2:
        return '未构成隐患'
      default:
        return text
    }
  },
  dateee: function(time) {
    let oldDate = new Date(time)
    let newDate = new Date()
    var dayNum = ''
    var getTime = (newDate.getTime() - oldDate.getTime()) / 1000

    if (getTime < 60 * 5) {
      dayNum = '刚刚'
    } else if (getTime >= 60 * 5 && getTime < 60 * 60) {
      dayNum = parseInt(getTime / 60) + '分钟前'
    } else if (getTime >= 3600 && getTime < 3600 * 24) {
      dayNum = parseInt(getTime / 3600) + '小时前'
    } else if (getTime >= 3600 * 24 && getTime < 3600 * 24 * 30) {
      dayNum = parseInt(getTime / 3600 / 24) + '天前'
    } else if (getTime >= 3600 * 24 * 30 && getTime < 3600 * 24 * 30 * 12) {
      dayNum = parseInt(getTime / 3600 / 24 / 30) + '个月前'
    } else if (time >= 3600 * 24 * 30 * 12) {
      dayNum = parseInt(getTime / 3600 / 24 / 30 / 12) + '年前'
    }

    let year = oldDate.getFullYear()
    let month = oldDate.getMonth() + 1
    let day = oldDate.getDate()
    let hour = oldDate.getHours()
    let minute = oldDate.getMinutes()
    let second = oldDate.getSeconds()
    // return dayNum+" "+year+"-"+month+"-"+day+" "+hour+":"+minute+":"+second;
    if (hour < 10 && minute > 10) {
      return year + '年' + month + '月' + day + '日' + ' ' + '0' + hour + ':' + minute + ':' + second
    } else if (hour > 10 && minute < 10) {
      return year + '年' + month + '月' + day + '日' + ' ' + hour + ':' + '0' + minute + ':' + second
    } else {
      return year + '年' + month + '月' + day + '日' + ' ' + hour + ':' + minute + ':' + second
    }
  },
  capitalize: function(text) {
    if (text.length > 10) {
      return text.substring(0, 10) + '...'
    } else if (text.length < 10) {
      return text
    }
  } // td内容长度大于10加省略号
}
export default vFilter



// WEBPACK FOOTER //
// ./src/api/fifter.js